import {Button, Card, CardContent, CardHeader, CardTitle, toast} from 'alm-react-components';
import {resetPassword} from 'aws-amplify/auth';
import {useContext, useLayoutEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import OtpResetPasswordForm from './OtpResetPasswordForm';
import ResetPasswordForm from './ResetPasswordForm';
import { AppContext } from '../../context/AppProvider';
import { ActionType, APPROUTES, BackendRespose, CognitoResponse,  constants,  corporateKeys,  StatusCode, UserType } from '../../assets/constants/constants';
import { getSllUser, getUserConfirmation, ResendInvite } from '../../services/user';
import {getSlectedLanguge } from '../../lib/utils';

const ResetPwd = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [codeSend, setCodeSend] = useState(false);
  const [username, setUsername] = useState('');
  const {state, dispatch } = useContext(AppContext);

  async function sendOtp(usernameValue: string) {
    //get username
    const value= usernameValue.toLowerCase()
    setUsername(value);
    dispatch({type: ActionType.SET_LOADING, payload: true});
    getUserConfirmation(value)
      .then(async(response: any) => {
        if(response?.data?.UserStatus === "FORCE_CHANGE_PASSWORD"){
          await ResendInvite(value).then((response: any)=>{
            if(response?.code==="ResendInviteLocked"){
              toast({
                description: t("Validations.retryLimitExhausted"),
                variant: "error",
              });
            }else if(response?.data?.code==="UserNotFoundException"){
              toast({
                description: t("Validations.userNotFoundError"),
                variant: "error",
              });
            }else{
              toast({
                description: t("Validations.temporaryPassword"),
                variant: "success",
              });
            }
            dispatch({type: ActionType.SET_LOADING, payload: false});
          })
        }else if(response?.data?.UserStatus === "CONFIRMED"){
          await resetPassword({ username: value ,options: {clientMetadata: {language: getSlectedLanguge()}}})
          .then(() => {
            toast({
              description: t("Validations.verificationCodeSentSuccessfully"),
              variant: "success",
            });
            setCodeSend(true);
            dispatch({type: ActionType.SET_LOADING, payload: false});
          })
          .catch((error) => {
            console.log(error.name)
            dispatch({type: ActionType.SET_LOADING, payload: false});
            if (error.name === 'LimitExceededException') {
              toast({
                description: t('ResetPassword.LimitExceededException'),
                variant: 'error',
              });
            } else if (
              error.name === 'UserNotFoundException' ||
              error.name === 'InvalidParameterException'||
              error.name  === CognitoResponse.notAuthorizedException || 
              error.name ===CognitoResponse.userNotFoundException){
              toast({description: t('Validations.userNotFoundError'), variant: 'error'});
            }
          });
        }else if (response?.data?.UserStatus !== "CONFIRMED" && response?.data?.UserStatus!=="FORCE_CHANGE_PASSWORD") {
          toast({description: t('Validations.userNotFoundError'), variant: 'error'});
        }else{
          toast({ description: t("Error.retryAgain"), variant: "error" });
        }
        dispatch({type: ActionType.SET_LOADING, payload: false});
      })
      .catch(() => {
        dispatch({type: ActionType.SET_LOADING, payload: false});
        toast({ description: t("Validations.userNotFound"), variant: "error" });
      });
  }
  
   useLayoutEffect(() => {
        window.scrollTo(0, 0);
        if (history.scrollRestoration) {
          history.scrollRestoration = "manual";
        }
      }, []);

  const onSubmitUsername = async (enteredUserName:string) => {
    if(state.user?.email && enteredUserName !== state.user?.email) {  
      toast({
        description: (
          <span dangerouslySetInnerHTML={{ __html: t("ResetPassword.anotherUserName") }} />
        ),
        variant: "error",
      });
    }else{
      dispatch({type: ActionType.SET_LOADING, payload: true});
      await getSllUser(enteredUserName).then(async (res: any) => {
        const headlessUserDetail = res.data;

        if(res?.status === StatusCode.ERR_BAD_REQUEST || res?.code === BackendRespose.detailsNotFound) {
          dispatch({type: ActionType.SET_LOADING, payload: false});
          toast({ description: t("ResetPasswordForm.userNotFound"), variant: "error" });
        } else if(headlessUserDetail?.userType === UserType.SOCIAL) {
          dispatch({type: ActionType.SET_LOADING, payload: false});
          toast({description: t('ResetPassword.socialUserMsg'), variant: 'error'});
        }else if(!headlessUserDetail.roles.includes(corporateKeys.LEARNER) && headlessUserDetail.corporateUserStatus === constants.DELETED) {
          dispatch({ type: ActionType.SET_LOADING, payload: false });
            toast({
              description: t('Common.accountDeletedMessage'),
              variant: 'error',
            });
        }else if(!headlessUserDetail.roles.includes(corporateKeys.LEARNER) && headlessUserDetail.corporateUserStatus !== constants.ACTIVE ){  
            dispatch({ type: ActionType.SET_LOADING, payload: false });
              toast({
                description: t('Common.accountDeactivatedMessage'),
                variant: 'error',
              });
        } else {
          setUsername(enteredUserName)
          sendOtp(enteredUserName)
        }
      })
    }
  }

  return (
    <>
      <div className=" md:min-w-[486px] md:max-w-[486px] px-4 md:mx-auto">
        <Card className="text-base border-0 bg-transparent">
          <CardHeader className="block text-left px-0">
            <CardTitle className="text-4xl font-light font-barlowLight">
              <span dangerouslySetInnerHTML={{ __html: t('LogIn.resetPassword') }} />
            </CardTitle>
          </CardHeader>
          <CardContent className="px-0">
            {!codeSend ? (
              <ResetPasswordForm
                username={username}
                onSubmitUsername={onSubmitUsername}
              />
            ) : (
              <OtpResetPasswordForm
                setCodeSend={setCodeSend}
                username={username}
                setUsername={setUsername}
                sendOtp={sendOtp}
              />
            )}
            <Button
              onClick={() => navigate(`${state.user?.email && !codeSend ? `${APPROUTES.changePassword}` : "/" }`) }
              variant={'link'}
              className="h-auto block mx-auto py-2 px-0 text-sm mb-6 underline dark:text-white"
            >
              <span dangerouslySetInnerHTML={{ __html:state.user?.email && !codeSend ? t('Common.back') : t('LogIn.loginHeading') }} />
            </Button>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

export default ResetPwd;
